import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type {
  ActivitySubscriptionPerRoleUpdateData,
  ActivitySubscriptions,
} from '@recruitee/activities-types';
import { Helpers } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsPerRoleHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public loadActivitySubscriptionsPerRole(roleId: number): Observable<ActivitySubscriptions> {
    return this.httpApi
      .get(`/tracking/activity_subscriptions_preset/${roleId}`, null, null)
      .pipe(map(data => data.activitySubscriptionsPresets));
  }

  public updateActivitySubscriptionPerRole(
    payload: ActivitySubscriptionPerRoleUpdateData,
  ): Observable<ActivitySubscriptions> {
    return this.httpApi.patch(`/tracking/activity_subscriptions_preset/${payload.roleId}`, null, {
      type: payload.type,
      value: payload.value,
      events: payload.events.map(Helpers.underscore),
    });
  }

  public resetToDefaultActivitySubscriptionPerRole(
    roleId: number,
  ): Observable<ActivitySubscriptions> {
    return this.httpApi
      .patch(`/tracking/activity_subscriptions_preset/${roleId}/reset_to_defaults`, null, null)
      .pipe(map(data => data.activitySubscriptionsPresets));
  }
}
